<template>
    <div>
        <!-- @slot Trigger element which opens the modal (Provides access to "open" method)  -->
        <slot name="trigger"
            v-bind="{
                open
            }"
        ></slot>
        <div v-if="useBackdrop"
            v-show="isOpen"
            class="c-modal-backdrop"
        ></div>
        <transition name="scale-in-out">
            <div v-show="isOpen"
                :class="['c-modal', staticWidthModifier,
                         {
                             'c-modal--has-backdrop': useBackdrop,
                             'c-modal--centered': centered
                         }]"
                :style="{
                    width: typeof this.staticWidth === 'number' ? `${staticWidth}px` : null
                }"
            >
                <div class="card card--dense c-modal__card">
                    <div class="c-modal_header card_inner bg-gray-50 border-b border-gray-200">
                        <BaseFlex justify="space-between">
                            <!-- @slot Modal title (may be used instead of "title" prop)  -->
                            <slot name="title">
                                <h3 class="text-gray-text mb-0">
                                    {{title}}
                                </h3>
                            </slot>

                            <BaseFlexItem width="content">
                                <BaseIcon
                                    icon="close"
                                    clickable
                                    @click.native="close()"
                                />
                            </BaseFlexItem>
                        </BaseFlex>
                    </div>

                    <div class="c-modal__body">
                        <!-- @slot primary modal content  -->
                        <slot></slot>
                    </div>

                    <div v-if="useFooter" class="c-modal__footer border-t border-gray-200 bg-white">
                        <div class="btn-set">
                            <!-- @slot (scoped) Modal action buttons. Provides access to "close" method  -->
                            <slot name="footer"
                                v-bind="{
                                    close
                                }"
                            ></slot>
                        </div>
                    </div>            
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import './c-modal.css';

export default {
    name: 'BaseModal',
    components: {},
    props: {

        /**
        * places a semi-transparent backdrop behind the modal
        */
        useBackdrop: Boolean,
        /** 
        * The title that appears at the top of the modal
        */
        title: String,
        /**
        * When visible, centers the modal in the screen
        */
        centered: Boolean,
        /**
        * Applies a static maximum width to the modal. 
        * String: small (320px), medium (600px), large (900px)
        * Number: custom max width in pixels
        */
        staticWidth: {
            type: [String, Number],
            validator(val) {
                return typeof val === 'number' || 
                [
                    'small',
                    'medium',
                    'large'
                ].includes(val);
            }
        },
        /**
         * Controls opening/closing of modal via prop
         */
        active: Boolean
    },
    data () {
        return {
            isOpen: false
        };
    },
    computed: {
        useFooter() {
            return !!this.$scopedSlots.footer;
        },
        staticWidthModifier(){
            return typeof this.staticWidth === 'string' ? `c-modal--${this.staticWidth}` : '';
        }
    },
    watch: {
        active() {
            if (this.active) {
                if (!this.isOpen) {
                    this.open();
                }
            } else {
                if (this.isOpen) {
                    this.close();
                }
            }
        }
    },
    methods: {
        open(){
            this.isOpen = true;
            this.$emit('open');
        },
        close(){
            this.isOpen = false;
            this.$emit('close');
        }
    }
};
</script>
